// extracted by mini-css-extract-plugin
module.exports = {"LoadingDot":"LoadingDots_LoadingDot__-XWCW","dot-animation":"LoadingDots_dot-animation__iahea"};